import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import FormLabel from "./formLabel"

function FormTextbox(props) {
  const { textDesc, form, field, maxLength, toUpperCase } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Field
            disabled={props.disabled}
            name={field.name}
            className={
              "inputbox " +
              (props.disabled ? "disableBGcolor " : " ") +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            onChange={e => {
              let value = e.target.value || ""
              if (toUpperCase) {
                value = value.toUpperCase()
              }
              form.setFieldValue(field.name, value)
            }}
            // onChange={event => {
            //   form.handleChange(event)
            // }}
            // onBlur={event => {
            //   form.handleBlur(event)
            //   field.onBlur(event)
            // }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={
              toUpperCase
                ? field.value.toUpperCase()
                : field.value
                ? field.value
                : ""
            }
          />
          {/* {errors && touched && (
              <span className="InputError">{errorMsg}</span>
            )} */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormTextbox
